<template>
    <v-select
        v-model="currentAccountManager"
        :options="options"
        placeholder="N/A"
        label="fullname"
        @click="storeValue()"
        @input="confirm()"
    />
</template>

<script>
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    export default {
        components: {'v-select': vSelect},
        props: ['options', 'commandId', 'value'],
    data: () => ({
        currentAccountManager: null,
        oldAccountManager: null
    }),
    created () {
        if (this.value && this.value.id && this.value.id != '') {
            this.currentAccountManager = Object.assign({}, this.value);
        } else {
            this.currentAccountManager = null;
        }
        this.storeValue();
    },
    mounted () {
        this.$bus.$on('validate-account-manager-modification-' + this.commandId, this.validateAccountManagerModification);
        this.$bus.$on('cancel-account-manager-modification-' + this.commandId, this.cancelAccountManagerModification);
    },
    methods: {
        confirm () {
            this.showModal({
                childVue: 'Commercial',
                dataModel: {
                    commandId: this.commandId,
                    accountManager: this.currentAccountManager
                },
            })
        },
        storeValue () {
            if (this.currentAccountManager && this.currentAccountManager.id && this.currentAccountManager.id != '') {
                this.oldAccountManager = Object.assign({}, this.currentAccountManager);
            } else {
                this.oldAccountManager = null;
            }
        },
        validateAccountManagerModification() {
            this.$emit('input', this.currentAccountManager);
            this.storeValue();
        },
        cancelAccountManagerModification() {
            this.currentAccountManager = this.oldAccountManager;
        }
    }
}
</script>
